import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import type { ProgressBarStripedProps } from './ProgressBarStriped.types';
import styles from './ProgressBarStriped.module.scss';
const widthPerRect = 11;
export const ProgressBarStriped: FC<ProgressBarStripedProps> = ({
  value,
  percent,
  showValue = true,
  className,
  classes
}) => {
  const [rectCount, setRectCount] = useState(0);
  const progressRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const updateRectCount = () => {
      if (progressRef.current) {
        const containerWidth = progressRef.current.offsetWidth;
        const count = Math.floor(containerWidth / widthPerRect);
        setRectCount(count);
      }
    };
    const resizeObserver = new ResizeObserver(updateRectCount);
    if (progressRef.current) {
      resizeObserver.observe(progressRef.current);
    }
    updateRectCount();
    return () => {
      if (progressRef.current) {
        resizeObserver.unobserve(progressRef.current);
        progressRef.current = null;
      }
    };
  }, []);
  return <div className={cn(styles.root, className)} data-sentry-component="ProgressBarStriped" data-sentry-source-file="ProgressBarStriped.tsx">
      <div className={cn(styles.progressContainer, classes?.container)} ref={progressRef}>
        <div className={cn(styles.progress, classes?.bar)} style={{
        width: `${percent}%`
      }} />
        <div className={styles.rectContainer}>
          {Array.from({
          length: rectCount
        }).map((_, index) => {
          return <div key={index} className={styles.rect} />;
        })}
        </div>
        {showValue && <div className={styles.valueContainer}>
            <span className={styles.value}>{value}</span>
          </div>}
      </div>
    </div>;
};